import { CommonSchemaIds } from '../../schemas/common.const.js';
export const dictionary = {
    schema: {
        [CommonSchemaIds.RANGE]: {
            title: 'Start date:End date',
            description: 'The start date:The end date',
            abbr: 'Start:End',
            cti: 'Provide the start date.:Provide the end date.'
        },
    }
};
